import {getAssetFullUrl} from "helpers/utils";
import {useLeagueDetail} from "hooks/league";
import BilliardLoader from "components/BilliardLoader";
import DeLeagueLive from "../de/live";
import SwissLeagueLive from "../swiss/live";
import LeaguePreJoin from "./LeaguePreJoin";
import {defaultLeague} from "interfaces/league";
import moment from "moment";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import "../shared/league.css";
import {useRecoilState} from "recoil";
import {userState} from "states/common";

/**
 * Chi tiết giải, màn CHƯA đăng ký (/league/:id). Mọi loại giải dùng chung layout
 * (LeaguePreJoin); Swiss dùng SwissLeagueLive và Đấu kép dùng DeLeagueLive (cả hai
 * tự lo cả pre-join/đã đăng ký).
 */
const LeagueDetail = () => {
    const {id = ""} = useParams();
    const [notAbleToJoin, setNotAbleToJoin] = useState(true);

    const league = useLeagueDetail(id, defaultLeague);
    const banner = getAssetFullUrl(league.banner);
    const [user] = useRecoilState(userState);

    useEffect(() => {
        if (user.id && league.id) {
            const now = moment();
            if (now.isSameOrAfter(league.startRegistrationDateObj) && now.isSameOrBefore(league.endRegistrationDateObj.endOf('day'))) {
                if (league.ranks && league.ranks.length > 0) {
                    if (user.ranking) {
                        const allowed = league.ranks.find(x => x.code === user.ranking.code);
                        if (allowed) {
                            setNotAbleToJoin(false)
                        }
                    }
                } else {
                    setNotAbleToJoin(false)
                }
            }
        }
    }, [user, league]);

    if (league.type === 'SWISS') {
        return <SwissLeagueLive leagueId={id}/>;
    }

    if (league.type === 'DOUBLE-ELIMINATION') {
        return <DeLeagueLive leagueId={id}/>;
    }

    /* Chưa tải xong thì league vẫn là defaultLeague — dựng LeaguePreJoin bằng nó
       sẽ bày ra một màn hình SAI: "Chưa công bố", "0 địa điểm", "Đăng nhập để
       tham gia" kể cả khi đã đăng nhập, rồi mấy trăm mili giây sau mới thay bằng
       nội dung thật. Chờ có id rồi hãy vẽ. */
    if (!league.id) {
        return (
            <div className="biadi">
                <BilliardLoader variant="center" label="Đang tải giải đấu…"/>
            </div>
        );
    }

    return <LeaguePreJoin league={league} banner={banner} notAbleToJoin={notAbleToJoin}/>;
};

export default LeagueDetail;
